export default __webpack_public_path__ + "static/backgroundDirectors--blurV-b8b2fb1e3762f398fc8208e901b9955f.jpg";